"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDelayLoadingWidgetIframe = void 0;
var _launcherTypes = require("conversations-internal-schema/widget-data/constants/launcherTypes");
const getDelayLoadingWidgetIframe = (widgetData, mobile) => {
  const {
    message
  } = widgetData;
  const {
    popOpenWelcomeMessage,
    popOpenWidget,
    popMessageOnSmallScreens,
    clientTriggers,
    launcherType
  } = message;
  const {
    displayOnTimeDelay
  } = clientTriggers;
  const {
    enabled,
    timeDelaySeconds
  } = displayOnTimeDelay;
  const timeDelay = timeDelaySeconds * 1000;
  const isPillLauncher = (widgetData.routingRuleDefinitionAI || widgetData.systemChatflow) && (launcherType === _launcherTypes.PILL || launcherType === _launcherTypes.DEFAULT);
  if (mobile) {
    return {
      shouldDelayLoadingIframe: !popMessageOnSmallScreens && enabled &&
      // This additional override allows you to disable the delay in showing the mobile launcher
      !window.ONLY_53_DISPLAY_LAUNCHER_ON_MOBILE,
      timeDelay
    };
  }
  return {
    shouldDelayLoadingIframe: !isPillLauncher && !popOpenWidget && !popOpenWelcomeMessage && enabled,
    timeDelay
  };
};
exports.getDelayLoadingWidgetIframe = getDelayLoadingWidgetIframe;